const Accessibility = () => import('@/assets/js/src/modules/accessibility/_views/Accessibility.vue')

export default [
    { name: 'Accessibility', path: '/accessibility', meta: { uiType: 'Overlay', }, component: Accessibility, },
]
